export default __webpack_public_path__ + "static/media/single_matrix_colour.84bdd2a9.svg";